import React from "react";
import "../CSS_stuff/CSSnewsletter.css"

export default function NewsletterPage() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        margin: 0,
      }}
    >
      <iframe
        title="Newsletter Signup"
        src="/Newsletter.html"
        style={{ flex: 1, width: '100%', border: 'none' }}
      />


      <footer
        style={{
          padding: "1rem",
          textAlign: "center",
          background: "#6f0999",
        }}
      >
        <a
          href="/whitelist-instructions.html"
          className="footer-link"
        >
          Whitelist Instructions
        </a>
      </footer>
    </div>
  );
}
